import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import RubriqueService from "../service/RubriqueSevice";
import {Historique} from "./Rubrique/Historique";
import {Connaitre} from "./Rubrique/Connaitre";
import {QueDitLaRecherche} from "./Rubrique/QueDitLaRecherche";
import {Organisation} from "./Rubrique/Organisation";

export const Rubrique = () => {

    const { wording } = useParams();

    const[rubrique, setRubrique] = useState([]);
    const[loadingRubrique, setLoadingRubrique] = useState(1);
    const fetchRubrique = async(wording) => {
        try{
            const data = await RubriqueService.find(wording);
            setRubrique(data);
            setLoadingRubrique(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchRubrique(wording);
    }, [wording]);


    const renderElement = (rubrique) => {
        switch (rubrique.id) {
            case '3273c97f-4f96-44b2-82a9-a5a15c53afad':
                return <Historique rubrique={rubrique} />;
            case 'dab606b2-e5ec-4968-8e25-3e40ce1caa1d':
                return <Connaitre rubrique={rubrique} />;
            case '0b6a453f-6b14-4f14-ae00-7710d8c229a2':
                return <QueDitLaRecherche rubrique={rubrique} />;
            case '3849d958-61dc-4b2b-9371-94bfc5c9691e':
                return <Organisation rubrique={rubrique} />;
            default:
                return <QueDitLaRecherche rubrique={rubrique} />;
        }
    };

    return (
        <>
            <Helmet>
                <title>{rubrique.meta_title}</title>
                <meta name="description" content={rubrique.meta_desc} />
            </Helmet>

            {renderElement(rubrique)}
        </>
    )
}